import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import classes from './ArticleTextWithImage.scss';
import Typography from '@mui/material/Typography'

export default class ArticleTextWithImage extends Component {
  static propTypes = {
    number : PropTypes.string,
    caption: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    src    : PropTypes.string,
    alt    : PropTypes.string,
    dir    : PropTypes.oneOf(['ltr', 'rtl']),
  }

  static defaultProps = {
    dir: 'ltr'
  }

  render() {
    const { number, caption, children, src, alt, dir } = this.props;

    const rootClasses = classNames(
      classes.articleTextWithImage,
      {
        [classes.ltr]: dir === 'ltr',
        [classes.rtl]: dir === 'rtl',
      }
    );

    return (
      <div className={rootClasses}>
        <div className={classes.text}>
          <Typography color="textSecondary" className={classes.number}>
            {number}
          </Typography>
          <h2 className={classes.caption}>
            {caption}
          </h2>
          <div className={classes.content}>
            {children}
          </div>
        </div>
        {
          src &&
            (
              <div className={classes.imageContainer}>
                <img src={src} alt={alt} className={classes.image} />
              </div>
            )
        }
      </div>
    );
  }
}
